/* eslint-disable no-restricted-imports */
import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { ModalProgressBar } from "../../../../../../../_metronic/_partials/controls";

export function PeriodeKurbanEditDialogHeader({ id }) {

    const [title, setTitle] = useState("");
    // Channel Redux state
    const { periodeKurbanForEdit, actionsLoading } = useSelector(
        (state) => ({
            periodeKurbanForEdit: state.periodeKurbans.periodeKurbanForEdit,
            actionsLoading: state.channels.actionsLoading,
        }),
        shallowEqual
    );

    useEffect(() => {
        let _title = id ? "" : "Periode Kurban Baru";
        if (periodeKurbanForEdit && id) {
            _title = "Edit Periode Kurban";
        }

        setTitle(_title);
        // eslint-disable-next-line
    }, [periodeKurbanForEdit, actionsLoading]);

    return (
        <>
            {actionsLoading && <ModalProgressBar variant="query" />}
            <Modal.Header closeButton>
                <Modal.Title id="modal-sizes-title-lg">{title}</Modal.Title>
            </Modal.Header>
        </>
    );
}
